import { Component, OnInit, ViewChild } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexYAxis,
  ApexLegend,
  ApexXAxis,
  ApexTooltip,
  ApexTheme,
  ApexGrid,
} from "ng-apexcharts";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  @ViewChild("chartObj") chart: any = ChartComponent;

  terms: any;
  salesChartOptions: any;
  rideChartOptions: any;
  vendingRevenueChartOptions: any;
  atzPosRevenueChartOptions: any;
  curr: any;
  select1: any = "day";
  select2: any = "day";
  select3: any = "week";
  select4: any = "week";
  membershipCount: any;
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private apiCallingService: ApiCallingService,
    public Globals: Globals,
  ) {
    this.curr = this.Globals.getUser().countryObject?.currency;

    this.chart1Set();
  }

  chart1Set() {
    this.salesChartOptions = {
      series: [
        { name: "Revenue", data: [0, 500, 600, 800, 2800, 900, 800, 2200] },
      ],
      chart: {
        fontFamily: "Nunito Sans,sans-serif",
        height: 250,
        type: "area",
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      markers: { size: 3, strokeColors: "transparent" },
      stroke: { curve: "smooth", width: "2" },
      colors: ["#2962ff", "#4fc3f7"],
      legend: { show: false },
      grid: {
        show: true,
        strokeDashArray: 0,
        borderColor: "rgba(0,0,0,0.1)",
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: true } },
      },
      xaxis: {
        type: "category",
        categories: ["Feb", "Mar", "Apr", "May", "Jun"],
        labels: { style: { colors: "#a1aab2" } },
      },
      tooltip: { theme: "dark" },
    };
    this.rideChartOptions = {
      series: [
        { name: "Revenue", data: [0, 500, 600, 800, 2800, 900, 800, 2200] },
      ],
      chart: {
        fontFamily: "Nunito Sans,sans-serif",
        height: 250,
        type: "area",
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      markers: { size: 3, strokeColors: "transparent" },
      stroke: { curve: "smooth", width: "2" },
      colors: ["#1EAA20", "#4fc3f7"],
      legend: { show: false },
      grid: {
        show: true,
        strokeDashArray: 0,
        borderColor: "rgba(0,0,0,0.1)",
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: true } },
      },
      xaxis: {
        type: "category",
        categories: ["Feb", "Mar", "Apr", "May", "Jun"],
        labels: { style: { colors: "#a1aab2" } },
      },
      tooltip: { theme: "dark" },
    };

    this.vendingRevenueChartOptions = {
      series: [],
      chart: {
        fontFamily: "Nunito Sans,sans-serif",
        height: 350,
        type: "line",
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 3 },
      markers: { size: 4 },
      colors: [
        "rgba(102, 216, 103, 0.7)",
        "rgba(209, 75, 73, 0.7)",
        "rgba(56, 105, 240, 0.7)",
      ],
      legend: { show: true },
      grid: {
        show: true,
        strokeDashArray: 0,
        borderColor: "rgba(0,0,0,0.1)",
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: true } },
      },
      tooltip: {
        shared: true,
        intersect: false,
        theme: "dark",
        yaxis: [
          {
            title: {
              text: `Revenue (${this.curr})`,
            },
            labels: {
              formatter: (val: number) => `${this.curr}${val}`,
            },
          },
          {
            opposite: true,
            title: {
              text: "Orders",
            },
            labels: {
              formatter: (val: number) => `${val}`,
            },
          },
        ],
      },
    };

    this.atzPosRevenueChartOptions = {
      series: [],
      chart: {
        fontFamily: "Nunito Sans,sans-serif",
        height: 350,
        type: "line",
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 3 },
      markers: { size: 4 },
      colors: [
        "rgba(102, 216, 103, 0.7)",
        "rgba(209, 75, 73, 0.7)",
        "rgba(56, 105, 240, 0.7)",
      ],
      legend: { show: true },
      grid: {
        show: true,
        strokeDashArray: 0,
        borderColor: "rgba(0,0,0,0.1)",
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: true } },
      },
      tooltip: {
        shared: true,
        intersect: false,
        theme: "dark",
        yaxis: [
          {
            title: {
              text: `Revenue (${this.curr})`,
            },
            labels: {
              formatter: (val: number) => `${this.curr}${val}`,
            },
          },
          {
            opposite: true,
            title: {
              text: "Orders",
            },
            labels: {
              formatter: (val: number) => `${val}`,
            },
          },
        ],
      },
    };
  }

  ngOnInit(): void {
    this.getPackageCount();
    this.getAllPackageCount();
    this.getRevenue();
    this.getRides();
    this.getTotalIncome();
    this.getVendingRevenue();
    this.getAtzPosRevenue();
  }

  ridesCount = 0;
  lockCount = 0;
  packageCount = 0;
  rentpackageCount = 0;
  leasepackageCount = 0;
  upcomingBookingCount = 0;
  allpackageCount = 0;
  revenue = 0;
  rides = 0;
  totalincome = 0;
  totalincome1 = 5559.75;
  totalVendingRevenue = 0;
  totalAtzPosRevenue = 0;
  advanceBooking = 0;
  getPackageCount() {
    const body = new HttpParams().set("userId", this.Globals.user._id);
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.DASHBOARD.GET_PACKAGE)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.packageCount = res.data.count;
        }
      });
  }
  getAllPackageCount() {
    const body = new HttpParams().set("userId", this.Globals.user._id);
    this.apiCallingService
      .callAPI(
        body,
        "GET",
        ConfigApi.URLS.DASHBOARD.ALL_GET_PACKAGE + "/" + this.Globals.user._id,
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          // console.log("🚀 ~ file: home.component.ts:170 ~ HomeComponent ~ .subscribe ~ res:", res)
          this.ridesCount = res.data.Ride;
          this.lockCount = res.data.Lock;
          this.rentpackageCount = res.data.Rent;
          this.allpackageCount = res.data.Sale;
          this.leasepackageCount = res.data.Lease;
          this.upcomingBookingCount = res.data.Upcoming_booking;
          this.membershipCount = res.data.userMembershipCount;

          this.advanceBooking = res.data.Advance_booking;
        }
      });
  }
  getRevenue() {
    const body = new HttpParams()
      .set("userId", this.Globals.user._id)
      .set(this.select1, 1);
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.DASHBOARD.GET_REVENUE)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          //this.revenue= res.data[res.data.length-1].Sunday;
          let keys: any = [];
          let values: any = [];
          for (var k of res.data) {
            keys.push(Object.keys(k)[0]);
            values.push(Object.values(k)[0]);
          }
          if (this.select1 == "week") {
            keys = ["Week 2", "Week 1", "Last week"];
          }
          this.salesChartOptions.xaxis = {
            type: "category",
            categories: keys,
            labels: {
              style: {
                colors: "#a1aab2",
              },
            },
          };
          this.salesChartOptions.series = [
            {
              name: "Revenue in " + this.curr,
              data: values,
            },
          ];
        }
      });
  }
  getTotalIncome() {
    const body = new HttpParams().set("userId", this.Globals.user._id);
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.DASHBOARD.GET_REVENUE)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.totalincome = res.data[0].Total;
        }
      });
  }
  getRides() {
    const body = new HttpParams()
      .set("userId", this.Globals.user._id)
      .set(this.select2, 1);
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.DASHBOARD.GET_RIDES)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.rides = res.data;
          let keys: any = [];
          let values: any = [];
          for (var k of res.data) {
            keys.push(Object.keys(k)[0]);
            values.push(Object.values(k)[0]);
          }
          if (this.select2 == "week") {
            keys = ["Week 2", "Week 1", "Last week"];
          }
          this.rideChartOptions.xaxis = {
            type: "category",
            categories: keys,
            labels: {
              style: {
                colors: "#a1aab2",
              },
            },
          };
          this.rideChartOptions.series = [
            {
              name: "Rides",
              data: values,
            },
          ];
        }
      });
  }
  getVendingRevenue() {
    const body = new HttpParams()
      .set("operator_id", this.Globals.user._id)
      .set(this.select3, 1);

    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.DASHBOARD.GET_VENDING_REVENUE)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          const apiData = res?.data?.stats || [];
          this.totalVendingRevenue = res?.data?.totalAllTimeEarning || 0;

          const revenueData: number[] = [];
          const ordersData: number[] = [];
          const cancelledData: number[] = [];
          const dateLabels: string[] = [];

          apiData.forEach((item: any) => {
            dateLabels.push(item.date);

            const revenue = parseFloat(
              item.highestSalePerDay?.split(" ")[0] || "0",
            );

            revenueData.push(revenue);
            ordersData.push(item.totalOrders || 0);
            cancelledData.push(item.cancelledOrders || 0);
          });

          this.vendingRevenueChartOptions.series = [
            {
              name: `Highest Sale(${this.curr})`,
              type: "column",
              data: revenueData,
              borderWidth: 2,
              borderRadius: 6,
            },
            {
              name: "Total Orders",
              type: "line",
              data: ordersData,
            },
            {
              name: "Cancelled Orders",
              type: "line",
              data: cancelledData,
            },
          ];

          this.vendingRevenueChartOptions.xaxis = {
            categories: dateLabels,
            labels: {
              formatter: (value: string) => {
                const date = new Date(value);
                const pad = (num: number) => num.toString().padStart(2, "0");
                const day = pad(date.getDate());
                const month = pad(date.getMonth() + 1);
                const yearShort = date.getFullYear().toString();
                const hours = pad(date.getHours());
                const minutes = pad(date.getMinutes());

                if (this.select3 === "day") {
                  return `${yearShort}/${month}/${day} ${hours}:${minutes}`;
                }

                if (this.select3 === "month") {
                  return `${month}/${day}`;
                }

                return value;
              },
            },
          };

          this.vendingRevenueChartOptions.plotOptions = {
            bar: {
              columnWidth:
                this.select3 === "month"
                  ? "40%"
                  : this.select3 === "week"
                    ? "20%"
                    : "15%",
              borderRadius: 4,
            },
          };

          this.vendingRevenueChartOptions.yaxis = [
            {
              title: { text: `Revenue (${this.curr})` },
              labels: {
                formatter: (val: number) => `${val.toLocaleString()}`,
              },
            },
            {
              opposite: true,
              title: { text: "Orders" },
              labels: {
                formatter: (val: number) => `${val}`,
              },
            },
          ];

          this.vendingRevenueChartOptions.tooltip = {
            shared: true,
            intersect: false,
            theme: "dark",
            y: {
              formatter: (
                val: number,
                { seriesIndex }: { seriesIndex: number },
              ) => {
                if (seriesIndex === 0) return `${val.toFixed(2)}`;
                if (seriesIndex === 1) return `${val} Orders`;
                if (seriesIndex === 2) return `${val} Orders`;
                return val;
              },
            },
          };

          this.vendingRevenueChartOptions = {
            ...this.vendingRevenueChartOptions,
          };
        }
      });
  }

  changeSaleschart() {
    this.getRevenue();
  }
  changeRidechart() {
    this.getRides();
  }
  changeVendingRevchart() {
    this.getVendingRevenue();
  }

  getAtzPosRevenue() {
    let url =
      ConfigApi.URLS.POS.DASHBOARD_STATISTICS +
      "?operator_id=" +
      this.Globals.user._id;

    if (this.select4) {
      url += "&" + this.select4 + "=1";
    }

    this.apiCallingService.callAPI({}, "GET", url).subscribe((res) => {
      if (this.apiCallingService.handleATZSuccess(res)) {
        const apiData = res?.data?.stats || [];
        this.totalAtzPosRevenue = res?.data?.totalAllTimeEarning || 0;

        const revenueData: number[] = [];
        const ordersData: number[] = [];
        const cancelledData: number[] = [];
        const dateLabels: string[] = [];

        apiData.forEach((item: any) => {
          dateLabels.push(item.date);

          const revenue = parseFloat(
            item.highestSalePerDay?.split(" ")[0] || "0",
          );

          revenueData.push(revenue);
          ordersData.push(item.totalOrders || 0);
          cancelledData.push(item.cancelledOrders || 0);
        });

        this.atzPosRevenueChartOptions.series = [
          {
            name: `Highest Sale(${this.curr})`,
            type: "column",
            data: revenueData,
            borderWidth: 2,
            borderRadius: 6,
          },
          {
            name: "Total Orders",
            type: "line",
            data: ordersData,
          },
          {
            name: "Cancelled Orders",
            type: "line",
            data: cancelledData,
          },
        ];

        this.atzPosRevenueChartOptions.xaxis = {
          categories: dateLabels,
          labels: {
            formatter: (value: string) => {
              const date = new Date(value);
              const pad = (num: number) => num.toString().padStart(2, "0");
              const day = pad(date.getDate());
              const month = pad(date.getMonth() + 1);
              const yearShort = date.getFullYear().toString();
              const hours = pad(date.getHours());
              const minutes = pad(date.getMinutes());

              if (this.select4 === "day") {
                return `${yearShort}/${month}/${day} ${hours}:${minutes}`;
              }

              if (this.select4 === "month") {
                return `${month}/${day}`;
              }

              return value;
            },
          },
        };

        this.atzPosRevenueChartOptions.plotOptions = {
          bar: {
            columnWidth:
              this.select4 === "month"
                ? "40%"
                : this.select4 === "week"
                  ? "20%"
                  : "15%",
            borderRadius: 4,
          },
        };

        this.atzPosRevenueChartOptions.yaxis = [
          {
            title: { text: `Revenue (${this.curr})` },
            labels: {
              formatter: (val: number) => `${val.toLocaleString()}`,
            },
          },
          {
            opposite: true,
            title: { text: "Orders" },
            labels: {
              formatter: (val: number) => `${val}`,
            },
          },
        ];

        this.atzPosRevenueChartOptions.tooltip = {
          shared: true,
          intersect: false,
          theme: "dark",
          y: {
            formatter: (
              val: number,
              { seriesIndex }: { seriesIndex: number },
            ) => {
              if (seriesIndex === 0) return `${val.toFixed(2)}`;
              if (seriesIndex === 1) return `${val} Orders`;
              if (seriesIndex === 2) return `${val} Orders`;
              return val;
            },
          },
        };

        this.atzPosRevenueChartOptions = {
          ...this.atzPosRevenueChartOptions,
        };
      }
    });
  }

  changeAtzPosRevchart() {
    this.getAtzPosRevenue();
  }
}
